import React from 'react';

const List = (props) => (
	<svg
		viewBox="0 0 18 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M4 2V0H18V2H4ZM4 8V6H18V8H4ZM4 14V12H18V14H4ZM1 2C0.716667 2 0.479167 1.90417 0.2875 1.7125C0.0958333 1.52083 0 1.28333 0 1C0 0.716667 0.0958333 0.479167 0.2875 0.2875C0.479167 0.0958334 0.716667 0 1 0C1.28333 0 1.52083 0.0958334 1.7125 0.2875C1.90417 0.479167 2 0.716667 2 1C2 1.28333 1.90417 1.52083 1.7125 1.7125C1.52083 1.90417 1.28333 2 1 2ZM1 8C0.716667 8 0.479167 7.90417 0.2875 7.7125C0.0958333 7.52083 0 7.28333 0 7C0 6.71667 0.0958333 6.47917 0.2875 6.2875C0.479167 6.09583 0.716667 6 1 6C1.28333 6 1.52083 6.09583 1.7125 6.2875C1.90417 6.47917 2 6.71667 2 7C2 7.28333 1.90417 7.52083 1.7125 7.7125C1.52083 7.90417 1.28333 8 1 8ZM1 14C0.716667 14 0.479167 13.9042 0.2875 13.7125C0.0958333 13.5208 0 13.2833 0 13C0 12.7167 0.0958333 12.4792 0.2875 12.2875C0.479167 12.0958 0.716667 12 1 12C1.28333 12 1.52083 12.0958 1.7125 12.2875C1.90417 12.4792 2 12.7167 2 13C2 13.2833 1.90417 13.5208 1.7125 13.7125C1.52083 13.9042 1.28333 14 1 14Z"
			fill="white"
		/>
	</svg>
);

export default List;
